// @flow
import React, { useState, useCallback } from 'react';
import { navigate } from '@reach/router';

import { maintenanceCostAllocationApi } from '../../lib/api';
import type { UserAccess, MaintenanceCostAllocation } from '../../lib/types';
import { formatDateTimeToString } from '../../lib/helpers';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';
import { approveTypes } from '../../lib/enum';
import { getBreadCrumbsByUrlForCard } from '../../lib/autoBreadcrumbs';

const { Field } = Card;

type InnerProps = {
  data: MaintenanceCostAllocation
};

type PageProps = {
  id: string,
  userAccess: UserAccess[]
};

const entryPointPath = '/admin/maintenance-cost-allocation/';

const InnerForm = (props: InnerProps) => {
  return (
    <>
      <Grid gutter="16px">
        <GridItem>
          <Field label="Подразделение">{props.data.orgUnitName}</Field>
        </GridItem>
        <GridItem>
          <Field label="Доля затрат на техническое обслуживание подрядом, %">
            {props.data.costContract}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Доля затрат на техническое обслуживание хоз.способом, %">
            {props.data.cost}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата начала">
            {formatDateTimeToString(props.data.startDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата окончания">
            {formatDateTimeToString(props.data.endDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Статус">{approveTypes[props.data.status]}</Field>
        </GridItem>
      </Grid>
    </>
  );
};

export default withUserAccess((props: PageProps) => {
  const [data: MaintenanceCostAllocation, setData] = useState({
    id: props.id,
    name: '',
    isAvailableForSelect: false
  });

  const breadCrumbs = getBreadCrumbsByUrlForCard(entryPointPath, data.id);

  const canEdit = props.userAccess.some(access =>
    addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit
      ? async () => {
          await maintenanceCostAllocationApi.delete(data.id);
          await navigate(`${entryPointPath}`);
        }
      : false,
    edit: canEdit
      ? async () => await navigate(`${entryPointPath}edit/${data.id}`)
      : false
  };

  const onFetch = useCallback(async () => {
    setData(await maintenanceCostAllocationApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Распределение затрат на ТО',
        access
      }}
      onFetch={onFetch}
    >
      <InnerForm data={data} />
    </CommonCardPage>
  );
});
